export default __webpack_public_path__ + "static/media/nasa-53884-unsplash (1).7f166488.png";